import { debounce, isEqual, omit } from 'lodash'
import { filterKeyWithNullValue } from '@/helper'

export default {
  data () {
    return {
      itemsPerPageOptions: [15, 30, 50, 100],
      totalItems: 0,
      pagination: {
        itemsPerPage: 15,
        sortBy: [],
        sortDesc: [],
        page: 1,
      },
      filters: {},
    }
  },

  watch: {
    pagination: {
      deep: true,
      immediate: false,
      handler (newValue, oldValue) {
        if (isEqual(JSON.parse(JSON.stringify(newValue)), JSON.parse(JSON.stringify(oldValue)))) {
          return
        }

        if (newValue.page !== oldValue.page) {
          this.updateTable()
          return
        }

        this.goToFirstPage()
      }
    },
  },

  methods: {
    async updateTable () {
      console.log('Please implement this method to update the data table')
    },

    filterTable () {
      this.goToFirstPage()
    },

    goToFirstPage () {
      if (this.pagination.page === 1) {
        this.updateTable()
        return
      }

      this.pagination = {
        ...omit(this.pagination, ['page']),
        page: 1
      }
    },

    transformPaginationParams () {
      const { itemsPerPage, page, sortBy, sortDesc } = this.pagination
      return filterKeyWithNullValue({
        limit: itemsPerPage,
        page: page,
        filters: filterKeyWithNullValue(this.filters),
        sorted_by: sortBy[0] || null,
        descending: (sortDesc[0] !== null && typeof sortDesc[0] !== 'undefined') ? (!!sortDesc[0]).toString() : null,
      })
    },

    updatePaginationForServerSide (pagination) {
      const { sortBy, sortDesc } = pagination

      if (!isEqual(this.pagination.sortBy, sortBy) || !isEqual(this.pagination.sortDesc, sortDesc)) {
        // ignore page attribute update
        this.pagination = {
          ...omit(this.pagination, ['sortBy', 'sortDesc']),
          sortBy,
          sortDesc
        }
      }
    },

    debounceFilterInput: debounce(function (key, value) {
      this.$set(this.filters, key, value)
    }, 500),
  }
}



// WEBPACK FOOTER //
// ./src/mixins/pagination.js